'use client';
import { useUpdateEffect } from 'ahooks';
import { reportEvent } from '@/app/utils';
import { usePathname } from '@/i18n/routing';

export function useReportPageTab(tab: string) {
  const pathname = usePathname();
  useUpdateEffect(() => {
    reportEvent('page_view', {
      page_name: `${pathname}/${tab}`,
      page_level: pathname.split('/').filter(Boolean).length + 1,
    });
  }, [tab]);
}
